export default {
	sales: 'Satış',
	'cashbox-name': 'Kasa adı',
	'name-of-the-financial-account': 'Finansal hesabın adı'
}